<template>
  <main class="w-screen h-screen bg-slate-200 center-all">
    <form
      @submit.prevent="submitForm"
      class="flex flex-col gap-3 w-1/5 border border-brand_gray2 p-5 rounded-md"
    >
      <div class="w-full mb-3 center-all">
        <h1 class="text-xl font-semibold text-brand_gray3">Register User</h1>
      </div>
      <!-- Username -->
      <IftaLabel>
        <InputText class="w-full" id="username" variant="filled" placeholder="" />
        <label for="username">Username</label>
      </IftaLabel>

      <!-- Password -->
      <IftaLabel>
        <Password
          id="password"
          class="w-full"
          variant="filled"
          inputClass="w-full"
          :feedback="false"
          toggleMask
        />
        <label for="password">Password</label>
      </IftaLabel>

      <!-- Confirm Password -->
      <IftaLabel>
        <Password
          id="password"
          class="w-full"
          variant="filled"
          inputClass="w-full"
          :feedback="false"
          toggleMask
        />
        <label for="password">Confirm Password</label>
      </IftaLabel>

      <!-- Name -->
      <IftaLabel>
        <InputText class="w-full" id="name" variant="filled" />
        <label for="name">Name</label>
      </IftaLabel>

      <!-- User Roles -->
      <IftaLabel>
        <Select class="w-full" variant="filled" />
        <label>User Role</label>
      </IftaLabel>

      <PrimeButton>Submit</PrimeButton>
    </form>
  </main>
</template>

<script>
// Imports
import { ref, inject } from "vue";

export default {
  setup() {
    // Dependency Vars
    const axios = inject("$axios");

    // Variables
    const newUserPayload = {
      username: null,
      password: null,
      confirmPasswrod: null,
      name: null,
      userRole: null,
    };

    // API Functions
    const submitForm = () => {
      alert("Form Submitted");
    };

    // Return
    return { newUserPayload, submitForm };
  },
};
</script>
